import React from 'react';

import robotRouters from './robotRoutes';
import robotV2Routes from './robotV2Routes';
import robotForStudentRoutes from './robotForStudentRoutes';
import robotForActivityRoutes from './robotForActivityRoutes';
import robotForCommonRoutes from './robotForCommonRoutes';

const routers = [
  ...robotRouters,
  ...robotV2Routes,
  ...robotForStudentRoutes,
  ...robotForActivityRoutes,
  ...robotForCommonRoutes
];

export default routers